import React from 'react';
import { cellExpr, scaleExpr } from './HeroGrid';

interface DashedPanelProps {
  cellsW?: number;
  cellsH?: number;
  /** Pixel inset (at BASE_CELL scale) from each side of the spanned cells. */
  inset?: number;
  label?: string;
}

/** Renders a dashed bracket panel spanning cellsW×cellsH cells, inset from the
 *  cell origin (0,0). HeroDecorations positions the cell. */
const DashedPanel: React.FC<DashedPanelProps> = ({
  cellsW = 1,
  cellsH = 1,
  inset = 14,
  label,
}) => {
  return (
    <div
      aria-hidden
      className="absolute rounded-md border border-dashed border-slate-300/70 opacity-60"
      style={{
        left: scaleExpr(inset),
        top: scaleExpr(inset),
        width: cellExpr({ cells: cellsW, px: -inset * 2 }),
        height: cellExpr({ cells: cellsH, px: -inset * 2 }),
      }}
    >
      <span className="absolute -top-px -left-px w-2.5 h-2.5 border-t-[1.5px] border-l-[1.5px] border-slate-400" />
      <span className="absolute -top-px -right-px w-2.5 h-2.5 border-t-[1.5px] border-r-[1.5px] border-slate-400" />
      <span className="absolute -bottom-px -left-px w-2.5 h-2.5 border-b-[1.5px] border-l-[1.5px] border-slate-400" />
      <span className="absolute -bottom-px -right-px w-2.5 h-2.5 border-b-[1.5px] border-r-[1.5px] border-slate-400" />
      {label && (
        <span className="absolute top-1.5 left-2 font-mono text-[9px] tracking-wider text-slate-400">
          {label}
        </span>
      )}
    </div>
  );
};

export default DashedPanel;
